export default function doesAnyFieldHaveIssue(fields) {
    return fields.filter(x => typeof x.warning !== 'undefined').length > 0;
}